import { Tooltip, type TooltipProps } from '@mui/material'
import React, { type ReactNode } from 'react'

interface IConditionalTooltipProps extends Partial<TooltipProps> {
	condition?: boolean
	label: string | ReactNode | undefined
	width?: number
	children: React.ReactElement
}

const ConditionalTooltip = ({
	label,
	children,
	condition = true,
	width = 300,
	placement = 'top',
	...props
}: IConditionalTooltipProps) =>
	condition && label ? (
		<Tooltip
			title={label}
			placement={placement}
			style={{ maxWidth: width }}
			{...props}
		>
			{children}
		</Tooltip>
	) : (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>{children}</>
	)

export { ConditionalTooltip }
